import * as React from 'react';
import { useMediaQuery, useTheme, Container, Box } from '@mui/material';

import AppBar from './AppBar';
import LanguageDrawer from './LanguageDrawer';
import Notification from './Notification';

interface Props {
  children?: React.ReactNode;
}

const Layout: React.FC<Props> = ({ children }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));

  return (
      <Box sx={{ display: 'flex' }}>
        <AppBar />
        <LanguageDrawer />
        <Box
            component="main"
            id="main-content"
            sx={{
              flexGrow: 1,
              height: '100vh',
              display: 'flex',
              flexDirection: 'column',
            }}
        >
          {/* AppBar Spacer */}
          <Box sx={(theme) => theme.mixins.toolbar} />
          {isSmall && <Box sx={(theme) => theme.mixins.toolbar} />}

          <Container
              maxWidth={false}
              sx={{
                height: 'auto',
                padding: theme.spacing(1),
                [theme.breakpoints.up('sm')]: {
                  padding: theme.spacing(2),
                },
                [theme.breakpoints.up('md')]: {
                  padding: theme.spacing(3),
                },
              }}
          >
            {children}
          </Container>
        </Box>
        <Notification />
      </Box>
  );
};

export default Layout;
